import { Link } from "react-router-dom";
import { treatments } from "@/data/treatments";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#F3EFEA] border-t border-[#E5E0DA] mt-24 md:mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2 mb-6">
              <span className="font-serif text-3xl tracking-tight">Natalia</span>
              <span className="text-[0.62rem] text-[0.72rem] text-[#8A847C]">Medical Aesthetics</span>
            </div>
            <p className="text-[#5C5C5C] max-w-md leading-relaxed text-[0.95rem]">
              Personalised, expert-led aesthetic care. Natural-looking results,
              medical precision, and a quiet space designed for you.
            </p>
            <div className="mt-10">
              <Link to="/book" data-testid="footer-book-cta" className="btn-primary">Book Consultation</Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Explore</div>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">Home</Link></li>
              <li><Link to="/about" className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">About Natalia</Link></li>
              <li><Link to="/treatments" className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">Treatments</Link></li>
              <li><Link to="/faq" className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">FAQ</Link></li>
              <li><Link to="/policies" className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">Policies</Link></li>
              <li><Link to="/book" className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">Book Consultation</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">Treatments</div>
            <ul className="space-y-3">
              {treatments.slice(0, 6).map((t) => (
                <li key={t.slug}>
                  <Link to={`/treatments/${t.slug}`} className="text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">{t.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">Visit</div>
            <p className="text-sm text-[#5C5C5C] leading-relaxed">
              12040 98th Ave NE, Unit 200<br />
              Kirkland, WA 98034
            </p>
            <div className="overline mt-8 mb-5">Contact</div>
            <p className="text-sm text-[#5C5C5C] leading-relaxed">
              <a href="tel:+13608204854" className="hover:text-[#1A1A1A] block">(360) 820-4854</a>
              <a href="https://www.instagram.com/ne_cosmetologist" target="_blank" rel="noreferrer" className="hover:text-[#1A1A1A] block mt-1">@ne_cosmetologist</a>
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#E5E0DA] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#8A847C] tracking-wide">© {new Date().getFullYear()} Natalia Medical Aesthetics. All rights reserved.</p>
          <p className="text-xs text-[#8A847C] tracking-wide">Master Aesthetician · Health Canada & FDA-cleared technology</p>
        </div>
      </div>
    </footer>
  );
};
